import type {
    BusinessServingContainer,
    Pagination,
} from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'businesses/serving-containers';

export function getServingContainers(
    query: BusinessServingContainer.SearchQuery
) {
    return api.get<Pagination<BusinessServingContainer>>(rootPath, query);
}

export function getServingContainer(id: number) {
    return api.get<BusinessServingContainer.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postServingContainer(
    data: BusinessServingContainer.CreateRequest
) {
    return api.post<BusinessServingContainer>(rootPath, data);
}

export function putServingContainer(
    id: number,
    data: BusinessServingContainer.UpdateRequest
) {
    return api.put<BusinessServingContainer>(`${rootPath}/${id}`, data);
}

export function deleteServingContainer({
    id,
}: BusinessServingContainer.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
